import { Box, Typography } from "@mui/material";
import { Close, Done, FileUpload, FindInPage, HelpOutline, Pending, Sync } from "@mui/icons-material";
import type { LifecycleStatus } from "../types/common";
import { getStatusMeta } from "../constants/lifecycleStatus";

const ICON_MAP: Record<string, React.ElementType> = {
  done: Done,
  close: Close,
  pending: Pending,
  sync: Sync,
  file_upload: FileUpload,
  find_in_page: FindInPage,
  help_outline: HelpOutline,
};

interface StatusBadgeProps {
  status: LifecycleStatus;
  /** Override display label (used for old invoices with invoice_status.label) */
  displayLabel?: string;
}

export default function StatusBadge({ status, displayLabel }: StatusBadgeProps) {
  const meta = getStatusMeta(status);
  const IconComponent = ICON_MAP[meta.icon] ?? HelpOutline;

  return (
    <Box
      component="span"
      sx={{
        display: "inline-flex",
        alignItems: "center",
        gap: "4px",
        pl: "4px",
        pr: "8px",
        py: "4px",
        borderRadius: "4px",
        color: meta.color,
        backgroundColor: meta.bgColor,
        border: meta.borderColor ? `1px solid ${meta.borderColor}` : "none",
        whiteSpace: "nowrap",
      }}
    >
      <IconComponent sx={{ fontSize: 12 }} />
      <Typography
        component="span"
        sx={{
          color: "inherit",
          fontSize: "10px",
          fontWeight: 500,
          lineHeight: "12px",
          textTransform: "uppercase",
        }}
      >
        {displayLabel || meta.label}
      </Typography>
    </Box>
  );
}
